.buttons {
  display: grid;
  gap: 16px;
  grid-auto-rows: 1fr;
  width: 100%;
}

.buttonGrid--3 {
  grid-template-columns: repeat(2, 1fr);
}

.buttonGrid--3-full {
  grid-template-columns: repeat(1, 1fr);
}

.buttonGrid--4 {
  grid-template-columns: repeat(2, 1fr);
}

.buttonGrid--5 {
  grid-template-columns: repeat(2, 1fr);
}

.button {
  min-width: 130px;
  height: 64px;
}

.buttonLabel--desktop {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .buttonGrid--3 {
    grid-template-columns: repeat(3, 1fr);
  }

  .buttonGrid--3-full {
    grid-template-columns: repeat(3, 1fr);
  }

  .buttonGrid--4 {
    grid-template-columns: repeat(4, 1fr);
  }

  .buttonGrid--5 {
    grid-template-columns: repeat(5, 1fr);
  }

  .buttonLabel--mobile {
    display: none;
  }

  .buttonLabel--desktop {
    display: block;
  }
}
